import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

function Accordion({ title, children = "" }) {
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState("0px");

  const contentSpace = useRef(null);

  function toggleAccordion() {
    setActive(!active);
    setHeight(active ? "0px" : `${contentSpace.current.scrollHeight}px`);
  }

  return (
    <div className="flex flex-col">
      <button
        className="flex w-full items-center justify-between border border-l-0 border-r-0 border-t-0 border-border-light-gray p-3 text-left font-medium text-text-primary hover:bg-background-light-gray"
        onClick={toggleAccordion}
      >
        <h2>{title}</h2>
        <p>{active ? "-" : "+"}</p>
      </button>
      <div
        ref={contentSpace}
        style={{ maxHeight: `${height}` }}
        className="transition-max-height overflow-auto duration-700 ease-in-out"
      >
        <div className="border border-t-0 border-border-light-gray p-4">
          {children}
        </div>
      </div>
    </div>
  );
}

Accordion.propTypes = {
  title: PropTypes.string,
  content: PropTypes.object,
};

export default Accordion;
